<form class="mb-3 mt-1" [formGroup]="form">
  <h4 class="mb-0" i18n>Personal information</h4>
  <p i18n>To continue, you need to enter your personal information here.</p>
  <div class="row g-3">
    <div class="col-md-6">
      <label class="form-label" i18n>First name</label>
      <input class="form-control" formControlName="first_name" autocomplete="given-name"
        [class.is-invalid]="form.get('first_name')?.invalid">
      <div *ngIf="form.get('first_name')?.invalid && form.get('first_name')?.touched" class="text-danger small" i18n>
        First name is required.</div>
    </div>
    <div class="col-md-6">
      <label class="form-label" i18n>Last name</label>
      <input class="form-control" formControlName="last_name" autocomplete="family-name"
        [class.is-invalid]="form.get('last_name')?.invalid">
      <div *ngIf="form.get('last_name')?.invalid && form.get('last_name')?.touched" class="text-danger small" i18n>Last
        name is required.</div>
    </div>
    <div class="col-md-6">
      <label class="form-label" i18n>Mobile phone</label>
      <input class="form-control" formControlName="mobile_phone" autocomplete="tel"
        [class.is-invalid]="form.get('mobile_phone')?.invalid">
      <div *ngIf="form.get('mobile_phone')?.invalid && form.get('confirm_password')?.touched" class="text-danger small"
        i18n>Mobile phone is optional but this does not look lile a valid number.</div>
    </div>

    <div class="col-12">
      <button type="submit" class="btn btn-primary w-100" (click)="save()" [disabled]="!this.form.valid || sending">
        <ng-container *ngIf="sending">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </ng-container>
        <ng-container *ngIf="!sending" i18n>
          Save information
        </ng-container>
      </button>
    </div>
  </div>
</form>